import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { PublicProject, PublicTimeEntry } from "../types/projects";
import { formatDate, formatHours, formatMoney } from "./format";

function fileSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
}

export function downloadHoursPdf(
  project: PublicProject,
  entries: PublicTimeEntry[],
  showPending: boolean,
): void {
  const doc = new jsPDF();
  const modeLabel = showPending ? "Pending hours" : "Total hours";
  const hours = showPending
    ? project.totals.pendingHours
    : project.totals.totalHours;
  const amount = showPending
    ? project.totals.pendingAmount
    : project.totals.totalAmount;

  doc.setFontSize(18);
  doc.text(project.name, 14, 20);

  doc.setFontSize(11);
  doc.setTextColor(90);
  doc.text(`${modeLabel} summary`, 14, 28);
  doc.text(`Generated ${formatDate(new Date())}`, 14, 34);

  doc.setTextColor(0);
  doc.setFontSize(12);
  doc.text(`${modeLabel}: ${formatHours(hours)}`, 14, 46);
  doc.text(
    `${showPending ? "Pending amount" : "Total amount"}: ${formatMoney(amount)}`,
    14,
    53,
  );

  autoTable(doc, {
    startY: 62,
    head: [["Date", "Hours", "Amount"]],
    body:
      entries.length === 0
        ? [[showPending ? "No pending hours." : "No hours logged yet.", "", ""]]
        : entries.map((entry) => [
            formatDate(entry.date),
            formatHours(entry.hours),
            formatMoney(entry.amount),
          ]),
    styles: { fontSize: 10 },
    headStyles: { fillColor: [16, 39, 129] },
    columnStyles: {
      1: { halign: "right" },
      2: { halign: "right" },
    },
  });

  const slug = fileSlug(project.name) || "project";
  const suffix = showPending ? "pending-hours" : "total-hours";
  doc.save(`${slug}-${suffix}.pdf`);
}
